<template>
  <div class="keeper-layout-box">
    <top-menu></top-menu>
    <div class="keeper-layout-sub-box">
      <router-view/>
    </div>
  </div>
</template>

<script>
import TopMenu from '@/views/components/KeeperTopMenu';
export default {
  name: 'KeeperLayout',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    TopMenu,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.$store.commit('loginInfo/set_login_type', 'keeper');
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.keeper-layout-box {
  .keeper-layout-sub-box {
    padding: 20px;
    margin: 50px 0 0 0;
  }
  @media (max-width: 767px) {
    .keeper-layout-sub-box {
      padding: 10px;
    }
  }
}
</style>
